export default "__VITE_ASSET__BERYxC2K__"